<template>
  <div style="text-align: center; line-height: 500px;font-size: 20px;">{{text}}</div>
</template>
<script>
let that;
export default {
  name: "null",
  data() {
    return {
      text: ""
    };
  },
  created() {
    // let isLogout=sessionStorage.getItem('isLogout')
    // if(isLogout=='true'){//用户处于退出登录状态
    var type = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
      ? "mobile"
      : "PC";
    if (type == "mobile") {
      this.text = "请用电脑访问,APP不支持";
    } else {
      this.text = "网站域名不存在,请输入正确网站地址";
    }
  },
  methods: {}
};
</script>